import {
  Entity,
  EntityRole,
  MapEntitiesLicensedState,
} from '@/legacy/types/entities/entities'
import { createCrudApi } from '@/libs/api/crud'
import { Nullable } from '@/libs/typing/base'

export type WhoAmIInfo = {
  entity: Nullable<Entity>
  roles: EntityRole[]
  auth0Id: Nullable<string>
  permissions: string[]
  licensedStates: Nullable<MapEntitiesLicensedState>
}

export const whoAmIApi = createCrudApi<WhoAmIInfo>('/api/entities/me')
